import siteInfo from "@/constants/siteInfo";
import Head from "next/head";

const VideoObjectSchema = ({
  title = "",
  description = "",
  canonical_url = "",
  image = "",
  publishedAt = "",
  modifiedAt = "",
  keywords = "",
  videoUrl = "",
  // videoDuration = "",
  authorName = "",
  authorCanonicalUrl = "",
}) => {
  return (
    <Head>
      <script
        id="VideoObjectSchema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "VideoObject",
            name: title,
            headline: title,
            description: description,
            url: canonical_url?.includes(process.env.NEXT_PUBLIC_WEBSITE_URL)
              ? `${canonical_url}`
              : process.env.NEXT_PUBLIC_WEBSITE_URL + `${canonical_url}`,
            datePublished: publishedAt,
            dateModified: modifiedAt,
            uploadDate: publishedAt,
            ...(keywords && { keywords: keywords }),
            thumbnailUrl: image,
            contentUrl: canonical_url?.includes(
              process.env.NEXT_PUBLIC_WEBSITE_URL
            )
              ? `${canonical_url}`
              : process.env.NEXT_PUBLIC_WEBSITE_URL + `${canonical_url}`,
            embedUrl: videoUrl,
            // duration: videoDuration,
            author: {
              "@type": "Person",
              name: authorName,
              url: authorCanonicalUrl?.includes(
                process.env.NEXT_PUBLIC_WEBSITE_URL
              )
                ? `${authorCanonicalUrl}`
                : process.env.NEXT_PUBLIC_WEBSITE_URL + `${authorCanonicalUrl}`,
            },
            publisher: {
              "@type": "Organization",
              name: siteInfo?.siteName,
              logo: {
                "@type": "ImageObject",
                url: `${siteInfo?.siteLogo}`,
                height: 60,
                width: 160,
              },
            },
            potentialAction: {
              "@type": "SeekToAction",
              target: {
                "@type": "EntryPoint",
                urlTemplate: canonical_url?.includes(
                  process.env.NEXT_PUBLIC_WEBSITE_URL
                )
                  ? `${canonical_url}` + "?t={seek_to_second_number}"
                  : process.env.NEXT_PUBLIC_WEBSITE_URL +
                    `${canonical_url}` +
                    "?t={seek_to_second_number}",
              },
              "startOffset-input": {
                "@type": "PropertyValueSpecification",
                valueRequired: "http://schema.org/True",
                valueName: "seek_to_second_number",
              },
            },
          }),
        }}
      />
    </Head>
  );
};

export default VideoObjectSchema;
